export default "__VITE_ASSET__DncIquYq__"